/**
 * Controla el diálogo de duplicar incidencia.
 */
IncidenciaRechazarCtrl.$inject = ['$log', '$scope', '$http'];
export default function IncidenciaRechazarCtrl($log, $scope, $http) {

    var URL_INCI_BASE = Sigo.var.path + '/incidencias';

    $scope.rechazando = false;

    $scope.comentariosIncidenciaActivos = Sigo.user.puedeVerComentariosIncidencia;
    $scope.puedeAnyadirRespuestasCiu = Sigo.user.puedeAnyadirRespuestasCiu;

    $scope.preguntandoRespuestaCiu = false;
    $scope.descartarPlantilla = true;

    $scope.rechazar = function () {
        if (!$scope.preguntandoRespuestaCiu && $scope.model.mostrarPlantilla && issetAndNotEmpty($scope.model.motivo) && $scope.puedeAnyadirRespuestasCiu) {
            $scope.preguntandoRespuestaCiu = true;

            $scope.model.respuesta_ciudadano = (Lang.get('respuestas_ciudadanos.incidencia_plantilla_rechazada', {}, 'es')
                + Lang.get('respuestas_ciudadanos.incidencia_plantilla_rechazada', {}, 'ca')).replace(/:motivo/g, $scope.model.motivo);

        } else if ($scope.rechazando === false) {
            var url = URL_INCI_BASE + '/rechazar/' + $scope.model.incidenciaId;

            var data = {motivo: $scope.model.motivo};

            if (!$scope.descartarPlantilla)
                data.plantilla = $scope.model.respuesta_ciudadano;

            var promesa = $http.post(url, data);

            $scope.rechazando = true;

            promesa.then(function (data) {
                $scope.model = data.data;
                $scope.dialog.close(data.data);
            });
            promesa.catch(function (error) {
                if (typeof error.data.message !== "undefined")
                    Sigo.UI.Messages.open([error.data.message], false);
            });
            promesa.finally(function () {
                $scope.rechazando = false;
            });
        }
    };

    $scope.cancelar = function () {
        $scope.dialog.cancel();
    };
}